import React, { Component } from 'react';

const redirectPaths = [
  "/",
];

class RedirectCheck extends Component {
  shouldRedirect = ()  => {
    var selectedStore = localStorage.getItem('selectedStore');
    if (selectedStore && redirectPaths.indexOf(this.props.location.pathname) >= 0) {
      return true;
    }
    return false;
  }

  componentWillMount =() => {
    var selectedStore = localStorage.getItem('selectedStore');
    if (this.shouldRedirect()){
      window.location = selectedStore;
      return;
    }
  }

  render(props) {
    if (this.shouldRedirect()) {
      return <div />
    }
    return (
      <div>
        {this.props.children}
      </div>
    );
  }
}

export default RedirectCheck;



// WEBPACK FOOTER //
// ./src/components/store-redirect/RedirectCheck.js